import { useState } from 'react'
import { useSelector } from 'react-redux'
import { aiImageSelectors } from 'store/features/aiImage/selectors'
import * as Styled from './styled'
import { useResponsive } from 'hooks/useResponsive'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import { normalizeAspectRatio } from 'utils/aspectRatio'
import ImageContainer from 'components/ImageContainer'

const GeneratedImage = () => {
  const aiImagePath = useSelector(aiImageSelectors.aiImagePath)
  const aspectRatio = useSelector(aiImageSelectors.aspectRatio)
  const isMobile = useResponsive(SMALL_DESKTOP_SIZE_BREAKPOINT)

  const [isImageLoading, setIsImageLoading] = useState(true)

  if (!aiImagePath || !isMobile) return null

  return (
    <Styled.GeneratedImageContainer>
      <ImageContainer
        filePath={aiImagePath}
        isImageLoading={isImageLoading}
        onImageLoad={() => setIsImageLoading(false)}
        aspectRatio={normalizeAspectRatio(aspectRatio)}
      />
    </Styled.GeneratedImageContainer>
  )
}

export default GeneratedImage
